// extracted by mini-css-extract-plugin
module.exports = {"root":"📦TitledSection__root--1DkwU","title":"📦TitledSection__title--3bFQi","labelContainer":"📦TitledSection__labelContainer--3szZ_"};